"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoDataError = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../shared/core");
var analytics_subjects_1 = require("../../analytics-subjects");
var copy_1 = require("../../copy");
var images_1 = require("../../images");
var sandwich_ids_1 = require("../../sandwich-ids");
var layout_styled_1 = require("../layout.styled");
var Footer = function () {
    var _a;
    var _b = (0, core_1.useComponents)(), InternalLink = _b.InternalLink, PrimaryCTALink = _b.PrimaryCTALink;
    var meterReads = (0, core_1.useLinks)().meterReads;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.METER_READS_INFO_LINK, properties: (_a = {}, _a[core_1.INTERNAL_EVENT_FLAG] = true, _a) },
        react_1.default.createElement(PrimaryCTALink, { href: meterReads(), as: InternalLink, "data-testid": "meter-reads-summary-no-data-link" },
            react_1.default.createElement(Copy, { copyKey: "meterReadsLink" }))));
};
exports.NoDataError = (0, react_1.forwardRef)(function (_a, ref) {
    var children = _a.children, heading = _a.heading, rest = __rest(_a, ["children", "heading"]);
    var _b = (0, core_1.useComponents)(), SummaryCard = _b.SummaryCard, Row = _b.Row, Col = _b.Col;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement(SummaryCard, __assign({ heading: heading, icon: "meterReads", footer: react_1.default.createElement(Footer, null) }, rest, { ref: ref }),
        react_1.default.createElement(Row, { isNested: true },
            react_1.default.createElement(Col, { span: 7 }, children ? children : react_1.default.createElement(Copy, { copyKey: "noDataMessage" })),
            react_1.default.createElement(Col, { span: 5 },
                react_1.default.createElement(layout_styled_1.StyledInfoImage, null,
                    react_1.default.createElement(ui_tools_1.Sandwich, { id: sandwich_ids_1.sandwichIds.noDataError },
                        react_1.default.createElement(images_1.NoDataImage, null)))))));
});
